import user from './modules/user'
import inboundReminder from './modules/inboundReminder'
import getters from './getters'
import { createStore } from 'vuex';

export default createStore({
  modules: {
    user,
    inboundReminder,
  },
  state: {},
  mutations: {},
  actions: {},
  getters
})
